<template>
  <span class="svg-icon-grid-view">
    <svg v-if="isTwoTone" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.67 4.65015C6.89002 4.65015 3 8.54017 3 13.3202C3 18.1002 6.89002 22.0002 11.67 22.0002C16.4501 22.0002 20.3401 18.1102 20.3401 13.3302C20.3401 8.55017 16.4501 4.65015 11.67 4.65015ZM12.42 13.0002C12.42 13.4102 12.08 13.7502 11.67 13.7502C11.26 13.7502 10.92 13.4102 10.92 13.0002V8.00016C10.92 7.59016 11.26 7.25016 11.67 7.25016C12.08 7.25016 12.42 7.59016 12.42 8.00016V13.0002Z" :fill="color"/>
      <path d="M14.5602 2.45001H8.78018C8.38018 2.45001 8.06018 2.13001 8.06018 1.73C8.06018 1.33 8.38018 1 8.78018 1H14.5602C14.9602 1 15.2802 1.32 15.2802 1.72C15.2802 2.12001 14.9602 2.45001 14.5602 2.45001Z" :fill="color"/>
    </svg>
    <svg v-else :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.75 13.125C19.75 17.472 16.222 21 11.875 21C7.528 21 4 17.472 4 13.125C4 8.778 7.528 5.25 11.875 5.25C16.222 5.25 19.75 8.778 19.75 13.125Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M11.875 8.3999V12.8999" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9.17505 2H14.575" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 28 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean },
  }
}
</script>